//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 import {getSignStatus,getServiceContents} from '@/assets/js/dict';
  import{downloadFile} from '@/assets/js/tool';
export default ({
    props:['proStates','xzState'],
    created(){
        getSignStatus().then(res=>{
            this.signList= res;
        })
        getServiceContents().then(res=>{
            this.serviceContents= res
        })
    },
    data() {
        return {
            proInfo:'',
            serviceContents:[],
            signState: false, //协议签订状态
            signList: [],
            dealInfoVisible: false,//协议详情弹窗
            zbList: [],
            dealVisible: false,
            dealStep: 1,
            dealList: [],  //需要签订的协议列表(中标的服务商列表)
            dealForm: {
                ownerName: '', //发包商
                providerName: '', //服务商
                arbitrationAddress: '',//仲裁地
                userId: '', //用户id
            },
            contracts: '',
            contUrl: '',
            Pdfh5:'',
            proShow:1,
            rules:{

            }
        }
    },
    methods: {
        // 下载文件
      downloadUrl(fileUrl,fileName){
        downloadFile(fileUrl,fileName)
      },
      //项目详情
      projectInfo(){
        this.$get('/tra/project/detail?id='+this.$route.query.id,function(res){
            if(res.code==200){
                this.proInfo= res.data
            }
        })
      },
        // 检测协议是否签订
        checkDeal() {
            this.$get('/tra/project/contract/isSign?traProjectId=' + this.$route.query.id, function (res) {
                if (res.code == 200) {
                    this.signState = res.data;  //true 签订了 false 未签订
                }
            })
        },
        // 发起协议
        uploadDeal() {
            this.userInfo(); //中标人信息列表
            this.dealVisible = true;
            this.dealStep = 1;
            this.dealForm.arbitrationAddress = '';
            this.dealForm.userId = '';
            this.projectInfo()
        },

        // 获取中标人列表
        userInfo() {
            this.$get('/tra/project/bid/zbList?projectId=' + this.$route.query.id, function (res) {
                if (res.code == 200) {
                    this.zbList = res.data;
                }
            })
        },
        // 预览协议 签订协议
        nextDeal() {
            this.$put('/tra/project/contract', this.contracts, function (res) {
                if (res.code == 200) {
                    this.$message.success('已发起签订!');
                    this.dealVisible = false;
                    this.dealInfoVisible = false;
                    this.getConList(); //协议签订列表
                    this.userInfo();
                }
            }, true)
        },

        // 提交签订协议需要的数据
        ensureDeal(dealForm) {
            this.dealForm.userId = this.zbList[0].userId
            this.dealForm.providerName = this.zbList[0].realName;
            this.$refs[dealForm].validate((valid) => {
                var map = {};
                var serviceContent = eval(this.proInfo.serviceContent).toString().split(',');
                var serviceContents = this.serviceContents;
                var sss = '';
                for (var i = 0; i < serviceContent.length; i++) {
                    for (var j = 0; j < serviceContents.length; j++) {
                        if (serviceContent[i] == serviceContents[j].dictCode) {
                            sss += serviceContents[j].dictName + '、'
                        }
                    }
                }
                sss = sss.substring(0, sss.length - 1);
                map['arbitrationAddress'] = this.dealForm.arbitrationAddress;
                map['serviceContent'] = sss;
                if (valid) { 
                    this.$post('/tra/project/contract',
                        {
                            traProjectId: this.$route.query.id,
                            map: map,
                            userId: this.dealForm.userId
                        },
                        function (res) {
                            if (res.code == 200) {
                                this.dealStep = 2;
                                this.contracts = res.data;
                                var href=''
                                if(window.location.href.indexOf('yunzikongjian')!=-1){
                                    href=window.location.href.split('/wechat/#/outsourcer')[0];
                                }else{
                                    href=window.location.href.split('/#/outsourcer')[0];
                                }
                                this.contUrl = href + res.data.contractFile.fileUrl;
                                this.getConList();
                            }
                            if(res.code==400){
                                this.$message.info(res.msg)
                            }
                        }, true)
                }
            })
        },


        // 协议签订的列表
        getConList() {
            this.$get('/tra/project/contract/list?traProjectId=' + this.$route.query.id + '&userType=' + getSession('user').currentUserType, function (res) {
                if (res.code == 200) {
                    this.dealList = res.data;
                }
            })
        },

        // 查看协议详情
        lookDeal(id) {
            this.traProjectContractId = id;
            this.dealInfoVisible = true;
            this.proShow=1
            this.$get('/tra/project/contract/detail?id=' + id, function (res) {
                if (res.code == 200) {
                    this.contracts = res.data;
                    this.contracts.contractFile = res.data.fileList[0];
                    var href=''
                    if(window.location.href.indexOf('yunzikongjian')!=-1){
                        href=window.location.href.split('/wechat/#/outsourcer')[0];
                    }else{
                        href=window.location.href.split('/#/outsourcer')[0];
                    }
                    if (res.data.signStatus == 1) {
                        this.contUrl = href+ res.data.signFileUrl
                    } else if (res.data.signStatus == 2) {
                        this.contUrl = href+ res.data.confirmFileUrl
                    } else {
                        this.contUrl =href + res.data.fileList[0].fileUrl
                    }
                }
            })
        },

        // 预览协议(和发起签订是同一个弹窗,里面的变量不一样)
        lookXy() {
            this.dealVisible = true;
            this.dealInfoVisible = false;
            this.dealStep = 2;
        },
    },
    mounted() {
        this.checkDeal()
        this.getConList()
    }
})
